
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aJO1s", function(module, exports) {

$parcel$export(module.exports, "notification", () => $7d14e8c91d5703d2$export$2adf6238a2d0dafa);
/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/ // Import project modules

var $12U9u = parcelRequire("12U9u");

var $e6rpZ = parcelRequire("e6rpZ");
const $7d14e8c91d5703d2$export$2adf6238a2d0dafa = {
    STAY_FOR_MS: 6000,
    active: false,
    translate: function(key, fallback) {
        if (typeof window !== 'undefined' && typeof window.t === 'function') return window.t(key);
        return fallback;
    },
    init: async function() {
        // Activate
        $7d14e8c91d5703d2$export$2adf6238a2d0dafa.active = true;
        // notification
        (0, $12U9u.qS)('body').insertAdjacentHTML('beforeend', '<div id="notification_container" class="notification-container"></div>');
        // Info
        // Add as first child to body
        (0, $12U9u.qS)('body').insertAdjacentHTML('beforebegin', '<div id="info_container" class="info-container"></div>');
        // Check for URL parameters
        $7d14e8c91d5703d2$export$2adf6238a2d0dafa.checkForURLParamater();
    },
    showSuccess: function(message) {
        if (!message) message = 'Saved';
        $7d14e8c91d5703d2$export$2adf6238a2d0dafa.easterEgg();
        return $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(message, 'success', '#notification_container');
    },
    showLoading: function(message) {
        return $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(message, 'loading', '#notification_container', true);
    },
    showInfo: function(message) {
        return $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(message, 'info', '#notification_container');
    },
    showError: function(message, metadata = null) {
        if (!message) message = 'Unknown error';
        // Stringify message if object
        if (typeof message === 'object') message = JSON.stringify(message);
        // Log error as activity
        (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.errorSeen, metadata ? {
            ...metadata,
            error: message
        } : message);
        // Show error notification
        return $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(message, 'error', '#notification_container', true);
    },
    remove: function(element) {
        // Element could have been removed before
        try {
            if (element.parentElement.innerHTML === '') element.parentElement.style.display = 'none';
            element.remove();
        } catch (error) {
            console.log('Element no longer exists');
        }
    },
    show: function(message, type, target, stay, action = null) {
        if (!$7d14e8c91d5703d2$export$2adf6238a2d0dafa.active) return;
        const targetElement = (0, $12U9u.qS)(target || '#notification_container');
        if (!targetElement) {
            console.log('Target element not found');
            return;
        }
        const div = document.createElement('div');
        div.classList.add(`notification`);
        if (type) div.classList.add(`info-${type}`);
        if (stay) div.classList.add(`notification-stay`);
        // Create the inner text div
        const textDiv = document.createElement('div');
        textDiv.classList.add('text');
        textDiv.innerHTML = message;
        div.appendChild(textDiv);
        // Create the close button div
        // if(stay){
        //   const closeDiv = document.createElement('div');
        //   closeDiv.classList.add('close');
        //   // Add an event listener to remove the parent div when close is clicked
        //   closeDiv.addEventListener('click', () => {
        //     notification.remove(div);
        //   });
        //   // Append textDiv and closeDiv to the main div
        //   div.appendChild(closeDiv);
        // }
        targetElement.appendChild(div);
        targetElement.style.display = 'flex';
        // Add action button
        if (action) $7d14e8c91d5703d2$export$2adf6238a2d0dafa.addAction(div, action);
        else if (stay && type !== 'loading') $7d14e8c91d5703d2$export$2adf6238a2d0dafa.addAction(div, {
            buttonText: $7d14e8c91d5703d2$export$2adf6238a2d0dafa.translate('notifications.hide', 'Hide'),
            callback: function() {
                $7d14e8c91d5703d2$export$2adf6238a2d0dafa.remove(div);
            }
        });
        if (!stay) setTimeout(()=>{
            $7d14e8c91d5703d2$export$2adf6238a2d0dafa.remove(div);
        }, $7d14e8c91d5703d2$export$2adf6238a2d0dafa.STAY_FOR_MS);
        return div;
    },
    update: function(message, div, type, hide = true, action = null) {
        // Check if div is in dom
        if (!div || !div.parentElement) {
            console.log('Div no longer in DOM');
            return;
        }
        div.querySelector('.text').textContent = message;
        // Add the new type
        div.classList.remove(`info-loading`);
        div.classList.add(`info-${type}`);
        if (action) $7d14e8c91d5703d2$export$2adf6238a2d0dafa.addAction(div, action);
        if (hide) {
            div.classList.remove('notification-stay');
            div.classList.add('notification-updated');
            setTimeout(()=>{
                $7d14e8c91d5703d2$export$2adf6238a2d0dafa.remove(div);
            }, $7d14e8c91d5703d2$export$2adf6238a2d0dafa.STAY_FOR_MS);
        }
    },
    addAction: function(div, action) {
        const buttonDiv = document.createElement('div');
        buttonDiv.classList.add('button');
        buttonDiv.textContent = action.buttonText;
        div.appendChild(buttonDiv);
        buttonDiv.addEventListener('click', function() {
            action.callback();
            $7d14e8c91d5703d2$export$2adf6238a2d0dafa.remove(div);
        });
    },
    easterEgg: function() {
        if (!$7d14e8c91d5703d2$export$2adf6238a2d0dafa.active) return;
        if (!(0, $12U9u.isAdmin)) return;
         // Only for pages /admin
        if (Math.random() > .01) return;
         // 1% chance
        const easterEggDiv = document.createElement('div');
        easterEggDiv.classList.add('easter-egg');
        document.body.appendChild(easterEggDiv);
        setTimeout(()=>{
            easterEggDiv.remove();
        }, 5000);
    },
    checkForURLParamater: function() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const info = params.has('info') ? decodeURIComponent(params.get('info')) : null;
        if (info) $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(info, params.get(`info_type`) || null, '#info_container', true);
        const notificationInUrl = params.has('notification') ? decodeURIComponent(params.get('notification')) : null;
        if (notificationInUrl) $7d14e8c91d5703d2$export$2adf6238a2d0dafa.show(notificationInUrl, params.get(`notification_type`) || null, '#notification_container');
        // Remove URL parameters
        [
            'info',
            'notification',
            'info_type',
            'notification_type'
        ].forEach((param)=>params.delete(param));
        const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
        window.history.replaceState({}, document.title, newUrl);
    },
    clear: function() {
        (0, $12U9u.qS)('#notification_container').innerHTML = '';
    }
};
// For all modules available
window.notification = $7d14e8c91d5703d2$export$2adf6238a2d0dafa;

});


//# sourceMappingURL=notification.84a29490.js.map
